import React from 'react'
import {
  Grid,
  GridCell,
  Flex,
  Title,
  SpacingVertical,
  FormElement,
  InputNumber,
  Text,
  Toggle,
  Divider,
  Collapsible
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import iconPadding from '../../icons/cd-icon-padding.svg'
import styled from '@emotion/styled'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  advancedPaddingState,
  defaultStyleState,
  pageState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import { isNumber } from 'Pages/EmailContentDefaults/shared/utils'

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding-right: 8px;
`

const StyledInputNumber = styled(InputNumber)`
  margin-right: 8px;
`

const StyleGrid = styled(Grid)`
  margin: 0 12px;
`

const StyledToggle = styled(Toggle)`
  margin-right: 8px;
`

const ButtonPadding = () => {
  const intl = useIntl()
  const { button } = useRecoilValue(styleState)
  const { button: defaultButton } = useRecoilValue(defaultStyleState)
  const { isEnabled } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)
  const setStyleState = useSetRecoilState(styleState)
  const [
    { buttonDesktopPaddingAdvanced },
    setadvancedPaddingState
  ] = useRecoilState(advancedPaddingState)

  const onChangeToggle = () => {
    if (buttonDesktopPaddingAdvanced) {
      setPageState(prev => ({
        ...prev,
        isDirty: true
      }))

      setStyleState(prev => ({
        ...prev,
        button: {
          ...prev.button,
          styles: {
            ...prev.button.styles,
            paddingBottom: prev.button.styles.paddingTop,
            paddingRight: prev.button.styles.paddingLeft
          }
        }
      }))
    }

    setadvancedPaddingState(prev => ({
      ...prev,
      buttonDesktopPaddingAdvanced: !prev.buttonDesktopPaddingAdvanced
    }))
  }

  const onChangePaddingTopBottom = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          paddingTop: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingTop,
          paddingBottom: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingTop
        }
      }
    }))
  }

  const onChangePaddingLeftRight = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          paddingLeft: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingLeft,
          paddingRight: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingLeft
        }
      }
    }))
  }

  const onChangePaddingTop = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          paddingTop: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingTop
        }
      }
    }))
  }

  const onChangePaddingBottom = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          paddingBottom: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingBottom
        }
      }
    }))
  }

  const onChangePaddingLeft = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          paddingLeft: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingLeft
        }
      }
    }))
  }

  const onChangePaddingRight = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          paddingRight: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.paddingRight
        }
      }
    }))
  }

  return (
    <>
      <Flex alignItems='center' justifyContent='space-between'>
        <Flex alignItems='center'>
          <StyledIcon src={iconPadding} />
          <Title variant='M'>
            {intl.formatMessage({
              id: 'Load.ContentDefaults.CommonPaddingTitleInt'
            })}
          </Title>
        </Flex>
        <Flex alignItems='center'>
          <StyledToggle
            variant='sm'
            checked={buttonDesktopPaddingAdvanced}
            onChange={onChangeToggle}
            disabled={!isEnabled}
          />
          <Text variant='bold'>
            {intl.formatMessage({
              id: 'Load.ContentDefaults.PaddingCustomLabel'
            })}
          </Text>
        </Flex>
      </Flex>
      <SpacingVertical variant='16' />

      <Collapsible collapsed={buttonDesktopPaddingAdvanced}>
        <StyleGrid cols={12}>
          <GridCell span={4}>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentDefaults.PaddingTopBottomLabel'
              })}
            >
              <Flex alignItems='center'>
                <StyledInputNumber
                  min={0}
                  max={60}
                  value={parseInt(button.styles.paddingTop.slice(0, -2))}
                  onChange={onChangePaddingTopBottom}
                  disabled={!isEnabled}
                />
                <Text>px</Text>
              </Flex>
            </FormElement>
          </GridCell>
          <GridCell span={4}>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentDefaults.PaddingLeftRightLabel'
              })}
            >
              <Flex alignItems='center'>
                <StyledInputNumber
                  min={0}
                  max={60}
                  value={parseInt(button.styles.paddingLeft.slice(0, -2))}
                  onChange={onChangePaddingLeftRight}
                  disabled={!isEnabled}
                />
                <Text>px</Text>
              </Flex>
            </FormElement>
          </GridCell>
        </StyleGrid>
      </Collapsible>

      <Collapsible collapsed={!buttonDesktopPaddingAdvanced}>
        <StyleGrid cols={12}>
          <GridCell span={4}>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentDefaults.PaddingTopLabel'
              })}
            >
              <Flex alignItems='center'>
                <StyledInputNumber
                  min={0}
                  max={60}
                  value={parseInt(button.styles.paddingTop.slice(0, -2))}
                  onChange={onChangePaddingTop}
                  disabled={!isEnabled}
                />
                <Text>px</Text>
              </Flex>
            </FormElement>
          </GridCell>
          <GridCell span={4}>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentDefaults.PaddingBottomLabel'
              })}
            >
              <Flex alignItems='center'>
                <StyledInputNumber
                  min={0}
                  max={60}
                  value={parseInt(button.styles.paddingBottom.slice(0, -2))}
                  onChange={onChangePaddingBottom}
                  disabled={!isEnabled}
                />
                <Text>px</Text>
              </Flex>
            </FormElement>
          </GridCell>
          <GridCell span={4} />
          <GridCell span={4}>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentDefaults.PaddingLeftLabel'
              })}
            >
              <Flex alignItems='center'>
                <StyledInputNumber
                  min={0}
                  max={60}
                  value={parseInt(button.styles.paddingLeft.slice(0, -2))}
                  onChange={onChangePaddingLeft}
                  disabled={!isEnabled}
                />
                <Text>px</Text>
              </Flex>
            </FormElement>
          </GridCell>
          <GridCell span={4}>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentDefaults.PaddingRightLabel'
              })}
            >
              <Flex alignItems='center'>
                <StyledInputNumber
                  min={0}
                  max={60}
                  value={parseInt(button.styles.paddingRight.slice(0, -2))}
                  onChange={onChangePaddingRight}
                  disabled={!isEnabled}
                />
                <Text>px</Text>
              </Flex>
            </FormElement>
          </GridCell>
        </StyleGrid>
      </Collapsible>

      <SpacingVertical />
      <Divider />
      <SpacingVertical />
    </>
  )
}

export default ButtonPadding
